import React, { useEffect } from "react";
import "./GoogleLogin.css";
import googleIcon from "../../../assets/google-icon.png";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

interface TokenPayload {
    email: string;
    exp: number;
    [key: string]: any;
}

const GoogleLogin: React.FC = () => {
    const navigate = useNavigate();
    const AI_CHAT_ADMIN_URL = "/ai-chat-admin"; // ✅ your redirect target
    const NLP_URL = "/nlp";

    const handleGoogleLogin = () => {
        window.location.href = "https://login.timesapp.biz/auth/google";
    };

    useEffect(() => {
        const tokenFromUrl = new URLSearchParams(window.location.search).get("token");
        if (tokenFromUrl) {
            localStorage.setItem("authToken", tokenFromUrl);
            window.history.replaceState({}, document.title, "/login"); // remove token from URL
        }

        const checkToken = async () => {
            const token = localStorage.getItem("authToken");
            if (!token) return;

            try {
                const decoded = jwtDecode<TokenPayload>(token);
                const now = Date.now() / 1000;

                if (now < decoded.exp - 5 * 60) {
                    // ✅ Token still valid
                    if (decoded.business_type_id === 1) {
                        navigate(AI_CHAT_ADMIN_URL);
                    } else if (decoded.business_type_id === 2) {
                        navigate(NLP_URL);
                    }
                } else {
                    // // 🔄 Token expired → refresh
                    // const res = await fetch("http://localhost:8080/auth/refresh", {
                    //     method: "POST",
                    //     headers: {
                    //         "Content-Type": "application/json"
                    //     },
                    //     body: JSON.stringify({ email: decoded.email })
                    // });
                    //
                    // const data = await res.json();
                    // console.log(data);
                    // if (res.ok && data.token) {
                    //     localStorage.setItem("authToken", data.token);
                    //     navigate(TARGET_URL);
                    // } else {
                    //     console.warn("❌ Token refresh failed");
                    //     localStorage.removeItem("authToken");
                    // }
                }
            } catch (error) {
                console.error("❌ Invalid or corrupted token", error);
                localStorage.removeItem("authToken");
            }
        };

        checkToken();
    }, [navigate]);

    return (
        <div className="google-login-container">
            <div className="login-card">
                <h2 className="login-title">התחבר עם Google</h2>
                <button className="google-login-button" onClick={handleGoogleLogin}>
                    <img src={googleIcon} alt="Google" className="google-icon" />
                    התחבר עם חשבון Google
                </button>
            </div>
        </div>
    );
};

export default GoogleLogin;